import React, { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Stack, VStack, Heading } from '@chakra-ui/react'

import { Page, PageHeader } from 'components'

import {
  ReportScoreCard,
  ReportFormIDCard,
  ReportProjectIDCard,
  ReportRecommendations,
  ReportDimensionalScoreCard,
  ReportLongitudinalScoreCard
} from '../components'
import { useFormSubmissionDetailQuery } from '../hooks'

export const FormSubmissionDetailPage = props => {
  const navigate = useNavigate()
  const { formSubmissionId } = useParams()
  const { data, loading } = useFormSubmissionDetailQuery(formSubmissionId)

  const handleBack = useCallback(() => navigate('..'), [navigate])

  return (
    <Page>
      <PageHeader heading={`Relatório #${formSubmissionId}`} onBack={handleBack} />

      <VStack align='stretch' spacing={5}>
        <Stack flex={1} spacing={5} align='stretch' direction={{ base: 'column', lg: 'row' }}>
          <ReportFormIDCard flex={2} loading={loading} report={data} />
          <ReportProjectIDCard flex={3} loading={loading} report={data} />
          <ReportScoreCard flex={1} loading={loading} report={data} />
        </Stack>

        <Stack flex={1} spacing={5} align='stretch' direction={{ base: 'column', lg: 'row' }}>
          <ReportLongitudinalScoreCard flex={3} loading={loading} report={data} />
          <ReportDimensionalScoreCard flex={2} loading={loading} report={data} />
        </Stack>

        <VStack align='stretch' spacing={5}>
          <Heading>Recomendaçōes da Avaliação</Heading>
          <ReportRecommendations loading={loading} report={data} />
        </VStack>
      </VStack>
    </Page>
  )
}

export default FormSubmissionDetailPage
